export const environment = {
  //url base para el componente usuario, esta url se encuentra expresada
  //en la api
  baseUrl: "https://dsbackend.tecazuay.edu.ec/talento/",
 // baseUrl: "http://localhost:8080/talento/",
};
